import { asyncLoad } from '@util'

export default {
  path: 'customService',
  indexRoute: {
    component: asyncLoad(() =>
      import('@components/LocalMerchant/CustomService')
    )
  },
  stat: '定制/异地服务',
  childRoutes: [
    {
      path: 'wedding',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/CustomService/Wedding/index')
      ),
      stat: '定制/异地服务>定制婚礼服务'
    },
    {
      path: 'nonlocal',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/CustomService/Nonlocal/index')
      ),
      stat: '定制/异地服务>外地婚礼服务'
    }
  ]
}
